module.exports = __webpack_public_path__ + "static/media/notify2.d409588e.png";